import { CustomEventWithDetail, html, type Html, View } from 'rune-ts';
import klass from './GoodsPartnerHeader.module.scss';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import UAParser from 'ua-parser-js';
import NewHeadroom from 'headroom.js';
import {
  goodsPartnerLogoIcon,
  MenuIcon,
  mspLogoIconV1,
  refundXIcon,
  ShareIcon,
} from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { each, pipe } from '@fxts/core';

export class navigateChapter extends CustomEventWithDetail<{
  target_section: string;
}> {}

export class GoodsPartnerHeader extends View<{ is_mobile: boolean }> {
  headroom?: NewHeadroom;
  current_theme = 'white';

  override template(): Html {
    const { is_mobile } = this.data;

    return is_mobile
      ? html`
          <div class="${klass.header}">
            <div class="${klass.menu_wrapper}">
              <a href="/"> ${mspLogoIconV1({ klass: klass.logo })} </a>
              <div class="${klass.icon_wrapper} ${font('16_bold')}">
                ${ShareIcon({ klass: klass.share })} ${MenuIcon({ klass: klass.menu })}
                ${refundXIcon({ klass: `${klass.close} ${klass.hidden}` })}
              </div>
            </div>
            <div class="${klass.nav_wrapper} ${font('20_bold')}">
              <div class="${klass.nav_item}" data-section="discount">할인 혜택</div>
              <div class="${klass.nav_item}" data-section="goods">굿즈 제작</div>
              <div class="${klass.nav_item}" data-section="all_in_one">올인원 서비스</div>
              <div class="${klass.nav_item}" data-section="marketing">홍보 마케팅</div>
              <div class="${klass.nav_item}" data-section="youtube">유튜브 쇼핑</div>
              <div class="${klass.nav_item}" data-section="goods_partners">굿즈 파트너스</div>
              <div class="${klass.nav_item}" data-section="faq">FAQ</div>
            </div>
          </div>
        `
      : html`
          <div class="${klass.header}">
            <a href="/@/goodspartner"> ${goodsPartnerLogoIcon({ klass: klass.logo })} </a>
            <div class="${klass.nav_wrapper} ${font('16_bold')}">
              <div class="${klass.nav_item}" data-section="discount">할인 혜택</div>
              <div class="${klass.nav_item}" data-section="goods">굿즈 제작</div>
              <div class="${klass.nav_item}" data-section="all_in_one">올인원 서비스</div>
              <div class="${klass.nav_item}" data-section="marketing">홍보 마케팅</div>
              <div class="${klass.nav_item}" data-section="youtube">유튜브 쇼핑</div>
              <div class="${klass.nav_item}" data-section="goods_partners">굿즈 파트너스</div>
              <div class="${klass.nav_item}" data-section="faq">FAQ</div>
              <div class="${klass.share}">공유하기</div>
            </div>
          </div>
        `;
  }

  protected override onRender() {
    const { is_mobile } = this.data;
    this.headroom = new NewHeadroom(this.element(), {});
    this.headroom.init();

    this.delegate('click', `.${klass.nav_item}`, (e: Event) => {
      const el = e.target as HTMLElement;

      if (el) {
        this.dispatchEvent(navigateChapter, {
          bubbles: true,
          detail: { target_section: el.dataset.section ?? '' },
        });

        if (is_mobile) this.closeMenu();
      }
    });

    this.delegate('click', `.${klass.share}`, () => {
      const is_app = MShopUtilF.isApp();
      const ua = new UAParser();
      const app_version = (/MarppleShopApp@(\w+.\w+.\w+)/gm.exec(ua.getUA()) || [])[1];

      if (is_app && app_version && app_version >= '1.1.0') {
        return MShopUtilF.postMessage({
          share: {
            title: `${T('마플샵')} - 굿즈 파트너스`,
            url: location.href,
          },
        });
      }

      try {
        navigator.clipboard
          .writeText(location.href)
          .then(() => {
            MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info', { position: klass.toast_position });
          })
          .catch(() => {
            MShopUtilF.popToastMsg(T('s_about::url_failed'), 'info');
          });
      } catch (e) {
        MShopUtilF.clipboard(location.href);
        MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
      }
    });

    if (is_mobile) {
      this.delegate('click', `.${klass.menu}`, this.openMenu);
      this.delegate('click', `.${klass.close}`, this.closeMenu);
    }
  }

  openMenu() {
    const page = document.querySelector<HTMLElement>('.goods-partner-landing');
    if (page) page.style.overflow = 'hidden';

    this.toggleHidden(`.${klass.share}, .${klass.menu}`, true);
    this.toggleHidden(`.${klass.close}`, false);
    this.element().classList.add(klass.open);
  }

  closeMenu() {
    const page = document.querySelector<HTMLElement>('.goods-partner-landing');
    if (page) page.style.overflow = '';

    this.toggleHidden(`.${klass.share}, .${klass.menu}`, false);
    this.toggleHidden(`.${klass.close}`, true);
    this.element().classList.remove(klass.open);
  }

  toggleHidden(target_klass_name: string, is_hidden: boolean) {
    pipe(
      this.element().querySelectorAll<HTMLElement>(target_klass_name),
      each((el: HTMLElement) => {
        if (is_hidden) {
          el.classList.add(klass.hidden);
        } else {
          el.classList.remove(klass.hidden);
        }
      }),
    );
  }

  setThemeColor(theme: string) {
    if (theme === this.current_theme) return;
    this.current_theme = theme;
    if (theme === 'white') {
      this.element().classList.add('headroom--white');
    } else {
      this.element().classList.remove('headroom--white');
    }
  }
}
